// The outcome buckets a deal score text normalizes to (see getScoreKey).
export enum ScoreConfig {
  FAILED = "failed",
  PENDING = "pending",
  MODERATE = "moderate",
  PASS = "pass",
  FULL_PASS = "fullpass"
}

export enum ScoreType {
  QUALIFICATION = "qualification",
  STAKEHOLDERS_MAPPING = "stakeholdersMapping",
  CHAMPION_SCORE = "championScore",
  POC = "poc",
  STAKEHOLDERS_APPROVAL = "stakeholdersApproval",
  GENERAL = "general"
}

interface ScoreConfigMapping {
  emptyText: string;
  valueMapping: {
    failed: string;
    pending: string;
    moderate?: string;
    pass: string;
    fullpass?: string;
  };
}

export const SCORE_CONFIGS: Record<ScoreType, ScoreConfigMapping> = {
  qualification: {
    emptyText: "addScore",
    valueMapping: {
      failed: "failed",
      pending: "pending",
      pass: "pass"
    }
  },
  stakeholdersMapping: {
    emptyText: "addMapping",
    valueMapping: {
      failed: "insufficient",
      pending: "partiallyMapped",
      pass: "fullyMapped"
    }
  },
  championScore: {
    emptyText: "rateChampion",
    valueMapping: {
      failed: "inadequate",
      pending: "pending",
      pass: "strong",
      moderate: "moderate"
    }
  },
  poc: {
    emptyText: "addPOCStatus",
    valueMapping: {
      failed: "notStarted",
      pending: "ongoing",
      pass: "ended"
    }
  },
  stakeholdersApproval: {
    emptyText: "stakeholdersApproval",
    valueMapping: {
      failed: "declined",
      pending: "pending",
      pass: "approved"
    }
  },
  general: {
    emptyText: "",
    valueMapping: {
      failed: "",
      pending: "pending",
      pass: "pass",
      fullpass: "fullpass"
    }
  }
};

export const getScoreKey = (scoreText: string): ScoreConfig =>
  scoreText.toLowerCase() as ScoreConfig;
